/**
 * Web Style Import
 *
 */

import './style/dnb-checkbox.scss'
